<template>
  <div class="projectContainer" @click="emitSelected" >
    <div class="bkgImage" :style="{ 'background-image': 'url(' + require(`/src/assets/photos/thumbnail/${project.path}`) + ')'}"></div>
  </div>
</template>

<script>

export default {
  name: 'PhotosTile',
  props: ['project', 'index'],
  methods: {
    emitSelected() {
      this.$emit('selected', 'photos', this.index)
    }
  },
  data() {
    return {
      showDetails: false
    }
  }
}
</script>

<style scoped>

  .projectContainer {
    margin: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 300ms;
    background-size: 300px;
    background-position: center center;
    background-repeat: no-repeat;
    min-height: 150px;
    border-radius: 5px;
  }

  .bkgImage {
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 300ms;
    background-size: 300px;
    background-position: center center;
    background-repeat: no-repeat;
    height: 150px;
    width: 100%;
    max-width: 300px;
  }

  .projectContainer:hover {
    cursor: pointer;
    transform: scale(1.05);
  }

  .detailsContainer {
    padding: 20px 0;
    display: flex;
    flex-direction: column;
  }

  .projectTitle {
    color: white;
    font-weight: 800;
    font-size: 1.5rem;
    text-shadow: 3px 3px 10px black;
    text-align: center;
  }

  .projectSubtitle {
    color: var(--accent-orange);
    font-style: italic;
    font-weight: 400;
    font-size: 1.3rem;
    margin-top: 5px;
  }

  .projectBody {
    color: white;
    margin: 20px 0;
    font-size: 1.3rem;
    line-height: 1.3;
  }

  @media screen and (min-width: 900px) {
    .projectContainer {
      flex-direction: row;
      min-height: 150px;
    }

    .projectTitle {
      font-size: 2rem;
    }

    .detailsContainer {
      padding: 10px 20px 10px 20px;
    }
  }

</style>
